import { createSlice } from '@reduxjs/toolkit';

import { TAbUseExperimentsState } from '../../types/abUseExperiments';

const initialState: TAbUseExperimentsState = [];

export const { reducer: experimentsReducer } = createSlice({
  name: 'experiments',
  reducers: {},
  initialState,
});
